import * as constants from '../constants';

export const FORM_VALUES_INITIAL_STATE = {
  code: '',
  description: '',
  kind: '',
  kind_value: '',
  title: '',
  units: '',
  start: '',
  expire: '',
  charge_box_pks: '',
  active: true,
};

const initialState = {
  userPks: [],
  formValues: FORM_VALUES_INITIAL_STATE,
};

export function voucherReducer(state = initialState, action) {
  switch (action.type) {
    case constants.SET_VOUCHER_FORM_VALUES: {
      return {
        ...state,
        formValues: action.formValues,
      };
    }
    case constants.SET_USERS_VOUCHER_LIST:
      return {
        ...state,
        userPks: action.userPks,
        usersDataList: action.usersDataList
      };

    default:
      return state;
  }
}
